<script>
import appConfig from "@/app.config";
import Km from "../../../components/document/late-payment3/km.vue"
import Cn from "../../../components/document/late-payment3/cn.vue"
import En from "../../../components/document/late-payment3/en.vue"
import { propertylatepaymentService } from "../../../services/propertyservice/propertylatepayment.service";
// import { contractService } from "../../../services/saleservice/contract.service";
/* eslint-disable no-console */
/**
 * Invoice-detail component
 */

export default {
  page: {
    title: "Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Km,
    Cn,
    En
  },
  data() {
    return {
      local: "kh",
      contract: [],
      
    };
  },
  mounted() {
    this.local = this.$route.params.local;
    console.log(this.local);

    propertylatepaymentService.byProperty({id: this.$route.params.id, locale: this.$route.params.local, step: 3}).then(response => {
        if(response.status == 200) {
          this.contract = response.data;
        }
    });
  },
  methods: {},
};
</script>

<template>

  
  <Cn v-if="local == 'cn'" :data="contract" />
  <En v-else-if="local == 'en'" :data="contract" />
  <Km v-else :data="contract" />

  <!-- <Cn :data="this.contract" /> -->
</template>